import React from 'react';
import TextField from '../../../../components/Textfields/TextField';
import PhoneNumber from '../../../../components/Textfields/PhoneNumber';
import { useAccountContext } from '../Data/accountContext';

export default function FormAccountContactAndName({ objectName, index, validation }) {
  const { account, setAccount } = useAccountContext();

  // if account type is a corporation the primary phone is the business phone number
  // this will be set as a secondary phone as it belongs to the primary officer/owner
  let phoneFieldName = 'phone';

  if (account.accountType === 'C' && objectName === 'primaryOwner') {
    phoneFieldName = 'secondaryPhone';
  }

  const handleChange = (e) => {
    const copy = { ...account };

    const input = e.currentTarget.name ? e.currentTarget : e.target;
    if (index !== undefined) {
      copy[objectName][index][input.name] = input.value;
    } else {
      copy[objectName][input.name] = input.value;
    }

    setAccount({ ...copy });
  };

  // get object or array index
  let validationObject = validation[objectName];
  let modelObject = account[objectName];
  if (index !== undefined) {
    validationObject = validationObject ? validationObject[index] : {};
    modelObject = modelObject[index];
  }

  return (
    <React.Fragment>
      <div className="grd-row">
        <div className="grd-cell">
          <TextField
            required={true}
            error={!!validationObject?.firstName}
            msg={validationObject?.firstName}
            max={50}
            name="firstName"
            label="First Name"
            placeholder="First Name"
            type="text"
            value={modelObject.firstName}
            onChange={handleChange}
          />
        </div>
        <div className="grd-cell">
          <TextField
            max={20}
            name="middleName"
            label="Middle Name"
            placeholder="Middle Name (Optional)"
            type="text"
            value={modelObject.middleName}
            onChange={handleChange}
          />
        </div>
        <div className="grd-cell">
          <TextField
            required={true}
            error={!!validationObject?.lastName}
            msg={validationObject?.lastName}
            max={20}
            name="lastName"
            label="Last Name"
            placeholder="Last Name"
            type="text"
            value={modelObject.lastName}
            onChange={handleChange}
          />
        </div>
      </div>
      <div className="grd-row">
        <div className="grd-cell">
          <PhoneNumber
            required={true}
            error={validationObject ? !!validationObject[phoneFieldName] : false}
            msg={validationObject ? validationObject[phoneFieldName] : ''}
            name={phoneFieldName}
            label="Phone Number"
            value={modelObject[phoneFieldName]}
            onChange={handleChange}
          />
        </div>
        <div className="grd-cell">
          <TextField
            required={true}
            error={!!validationObject?.email}
            msg={validationObject?.email}
            max={50}
            name="email"
            label="Email Address"
            placeholder="Email Address"
            type="text"
            value={modelObject.email}
            onChange={handleChange}
          />
        </div>
      </div>
    </React.Fragment>
  );
}
